export const PAYEE_PARTIAL_EDIT_FILTER = {
  mobile_country_code: '',
  mobile_number: '',
  email: '',
  bank_account_number: '',
  country_code: '',
  bank_name: '',
  card_holder_name: '',
  re_enter_account_number: '',
  routing_code_value_1: '',
  routing_code_value_2: '',
  routing_code_value_3: '',
  additional_id_value_1: '',
  additional_id_value_2: '',
  additional_id_value_3: '',
  additional_id_value_4: '',
  additional_id_value_5: '',
  unit_number: '',
  street_number: '',
  card_number: '',
  signature: '',
  street: '',
  street_type: '',
  street_name: '',
  suburb: '',
  state: '',
  block_number: '',
  floor_number: '',
  building_name: '',
  district: '',
  address1: '',
  address2: '',
  city: '',
  postcode: '',
  building_number: '',
  province: '',
  is_card_number_updated: '',
  card_issuer_name: '',
  beneficiary_identification_type: '',
  beneficiary_identification_value: '',
  beneficiary_identity_number: '',
  updated_country_code: ''
};
